module.exports = __webpack_public_path__ + "como-font.svg?5693072f67a3cf1e3c63de0a47454903";